import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';

export const TrendsPreview = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const trends = [
    {
      emoji: '❄️',
      name: t('trends.minimalist', 'Minimalist'),
      color: 'text-blue-600',
    },
    {
      emoji: '🌿',
      name: t('trends.rustic', 'Rustic'),
      color: 'text-green-600',
    },
    {
      emoji: '✨',
      name: t('trends.tech', 'Tech'),
      color: 'text-purple-600',
    },
    {
      emoji: '🎭',
      name: t('trends.glam', 'Glamorous'),
      color: 'text-pink-600',
    },
  ];

  return (
    <section className="w-full max-w-4xl mx-auto py-12 px-4 bg-gradient-to-br from-primary/5 to-primary/10 rounded-2xl">
      <div className="text-center space-y-4 mb-8">
        <div className="inline-block px-4 py-1 bg-primary/20 rounded-full">
          <span className="text-sm font-semibold text-primary">
            {t('trends.badge', '2025 TRENDS')}
          </span>
        </div>
        <h2 className="text-3xl font-bold text-foreground">
          {t('trends.title', 'Discover Your Christmas Style')}
        </h2>
        <p className="text-muted-foreground">
          {t('trends.subtitle', 'Which 2025 trend matches your personality?')}
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {trends.map((trend, index) => (
          <div
            key={index}
            className="flex flex-col items-center p-4 bg-background rounded-lg hover:shadow-lg transition-shadow"
          >
            <span className="text-4xl mb-2">{trend.emoji}</span>
            <span className={`text-sm font-medium ${trend.color}`}>{trend.name}</span>
          </div>
        ))}
      </div>

      <div className="text-center space-y-4">
        <Button
          onClick={() => navigate('/quiz')}
          size="lg"
          className="bg-primary hover:opacity-90 text-primary-foreground"
        >
          <Sparkles className="mr-2 h-5 w-5" />
          {t('trends.cta', 'Take the Style Quiz')}
        </Button>
        <div>
          <Button
            onClick={() => navigate('/trends')}
            variant="link"
            className="text-primary"
          >
            {t('trends.learnMore', 'Learn more about 2025 trends')} →
          </Button>
        </div>
      </div>
    </section>
  );
};
